module.exports = __webpack_public_path__ + "static/media/01-home.e4bee2b0.png";